import React from 'react';

const MongoDB_Drivers = () => {
  return (
    <div>
      <h1>MongoDB_Drivers Component</h1>
      <p>This is the MongoDB_Drivers page.</p>
    </div>
  );
};

export default MongoDB_Drivers;
